import { createApiConstants } from '@saucelabs/sl-util-redux';

import { NAMESPACE } from './constants';

const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

export const SEARCH = createApiNamespacedConstants('SEARCH');
export const FETCH_FACET = createApiNamespacedConstants('FETCH_FACET');
export const TEAMLIST_GET = createApiNamespacedConstants('TEAMLIST_GET');
export const UPDATE_QUERY = `${NAMESPACE}/UPDATE_QUERY`;
export const UPDATE_DATE_FACET = `${NAMESPACE}/UPDATE_DATE_FACET`;
export const UNION_FACET_VALUE = `${NAMESPACE}/UNION_FACET_VALUE`;
export const UPDATE_FACET_VALUE = `${NAMESPACE}/UPDATE_FACET_VALUE`;
export const UPDATE_SORT = `${NAMESPACE}/UPDATE_SORT`;
export const INCREMENT_PAGE = `${NAMESPACE}/INCREMENT_PAGE`;
export const RESET_PAGE = `${NAMESPACE}/RESET_PAGE`;
export const EXTEND_FACET = `${NAMESPACE}/EXTEND_FACET`;
